import { Rocket } from "lucide-react";

export default function FinalCTA() {
  return (
    <section
      data-testid="wc-final-cta"
      className="relative bg-[#30265b] text-white py-20 sm:py-28 overflow-hidden wc-grain"
    >
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-[#673dfc]/40 blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-[#d3fc3a]/10 blur-3xl" />
      <div className="max-w-4xl mx-auto px-5 sm:px-8 relative text-center">
        <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
          You&apos;re One Decision Away From Building Your{" "}
          <span className="text-[#d3fc3a]">$10K/Month Recurring Business.</span>
        </h2>
        <p className="mt-6 font-display font-semibold text-xl sm:text-2xl text-white/90 max-w-2xl mx-auto leading-snug">
          Imagine Where Your Business Could Be 12 Months From Today.
        </p>
        <p className="mt-5 text-lg text-white/80 max-w-2xl mx-auto leading-relaxed">
          Stop trying to do everything yourself.
          <br />
          Let our Done-for-You Business Growth Accelerator become your dedicated marketing team — keeping your business visible, generating qualified leads, and helping you build predictable recurring income while you focus on closing sales and serving your clients.
        </p>
        <div className="mt-9 flex justify-center">
          <a
            href="#pricing"
            data-testid="wc-final-cta-primary"
            className="bg-[#d3fc3a] text-[#1a1a24] font-display font-semibold text-base sm:text-lg rounded-full px-8 py-4 sm:py-5 flex items-center gap-2 hover:-translate-y-1 hover:shadow-2xl hover:shadow-[#d3fc3a]/25 transition-transform duration-300"
          >
            <Rocket size={18} /> Yes, Help Me Build My $10K/Month Business
          </a>
        </div>
      </div>
    </section>
  );
}
